import api from '@/api/Api'

export default {

  masterData () {
    return api.get('/environment/master_data')
  }
}
